module.exports = __webpack_public_path__ + "img/Telderi.d9fe532f.png";